
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_39_0_FormField";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_39_0_FormField__root","text-small-thin":"wds_1_39_0_StylableTypography__text-small-thin","text-tiny-thin":"wds_1_39_0_StylableTypography__text-tiny-thin","label":"wds_1_39_0_FormField__label","labelIndicators":"wds_1_39_0_FormField__labelIndicators","children":"wds_1_39_0_FormField__children","statusMessage":"wds_1_39_0_FormField__statusMessage","suffix":"wds_1_39_0_FormField__suffix","labelRow":"wds_1_39_0_FormField__labelRow","labelRowMain":"wds_1_39_0_FormField__labelRowMain","asterisk":"wds_1_39_0_FormField__asterisk","infoIcon":"wds_1_39_0_FormField__infoIcon","statusIcon":"wds_1_39_0_FormField__statusIcon"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"suffixHorizontalPadding":"12px","inlineLabelMinHeight":"36px","childrenMargin":"6px","suffixHeight":"18px"}; 
export var vars = {}; 




